<template>
  <div class="not-found">
    <div class="not-found__inner">
      <div class="not-found__content">
        <h1 class="not-found__code" data-text="404">404</h1>

        <div class="not-found__divider"></div>

        <h2 class="not-found__title">Маршрут не найден</h2>
        <p class="not-found__text">
          Этот адрес не существует или был изменён.
          <br />
          Груз явно свернул не туда.
        </p>

        <button
          class="not-found__btn"
          type="button"
          @click="goToHomePage"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          На главную
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundPage",

  methods: {
    goToHomePage() {
      this.$router.push({ name: "Home" }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          this.$router.push("/");
        }
      });
    },
  },
};
</script>

<style scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70dvh;
  padding: 40px var(--base-out-indent);
  background-color: #f0f0f0;
}

.not-found__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  width: 100%;
  max-width: 640px;
}

.not-found__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.not-found__code {
  position: relative;
  font-size: clamp(80px, 16vw, 130px);
  font-weight: 900;
  letter-spacing: 8px;
  line-height: 1;
  margin: 0 0 4px;
  color: var(--color-dark);
  text-shadow: 0 2px 12px rgba(30, 30, 47, 0.12);
}

.not-found__code::before,
.not-found__code::after {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.not-found__code::before {
  color: var(--color-yellow);
  animation: glitch1 2.5s infinite;
  clip-path: polygon(0 0, 100% 0, 100% 45%, 0 45%);
}

.not-found__code::after {
  color: var(--color-green);
  animation: glitch2 2.5s infinite;
  clip-path: polygon(0 55%, 100% 55%, 100% 100%, 0 100%);
}

@keyframes glitch1 {
  0%,
  100% {
    transform: translate(0);
  }
  20% {
    transform: translate(-3px, 2px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(2px, 2px);
  }
  80% {
    transform: translate(3px, -2px);
  }
}

@keyframes glitch2 {
  0%,
  100% {
    transform: translate(0);
  }
  20% {
    transform: translate(3px, -2px);
  }
  40% {
    transform: translate(2px, 2px);
  }
  60% {
    transform: translate(-2px, -2px);
  }
  80% {
    transform: translate(-3px, 2px);
  }
}

.not-found__title {
  font-size: 22px;
  font-weight: 700;
  color: var(--color-dark);
  margin-bottom: 12px;
}

.not-found__text {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.7;
  margin-bottom: 36px;
}

.not-found__btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 13px 32px;
  background: var(--color-green);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.15s ease,
    box-shadow 0.2s ease;
  box-shadow: 0 4px 16px rgba(0, 191, 165, 0.3);
}

.not-found__btn:hover {
  background: var(--color-green-hover);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 191, 165, 0.4);
}

.not-found__btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 191, 165, 0.25);
}

@media (max-width: 767px) {
  .not-found {
    padding: 24px var(--base-in-indent);
    align-items: flex-start;
    padding-top: 48px;
  }

  .not-found__inner {
    gap: 32px;
  }

  .not-found__code {
    letter-spacing: 4px;
  }

  .not-found__title {
    font-size: 20px;
  }
}
</style>
